import { Link } from 'react-router-dom';
import { Carousel, Image } from 'react-bootstrap';


const ProductCarousel = ({ products }) => {
  if (!products || products.length === 0) return null;

  return (
    <Carousel pause='hover' className='bg-primary mb-4'>
      {products.map((product) => (
        <Carousel.Item key={product._id}>
          <Link to={`${product.linkTo}`}>
            <Image
              src={product.image}
              alt={product.name}
              className='carousel-img'
              fluid
            />
            <Carousel.Caption className='carousel-caption'>
              <h2 className='text-white text-right'>{product.name}</h2>
            </Carousel.Caption>
          </Link>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default ProductCarousel;
